import { CompanySelector, type CompanyOption } from '@/components/global/selectors/CompanySelector';

/**
 * What the picker hands back. The selector treats the code and country as optional —
 * its callers store them as plain strings, so they are filled in here rather than at
 * every call site.
 */
export interface PickedCompany {
    id: string;
    name: string;
    company_code: string;
    country: string;
}

interface CompanyPickerProps {
    selectedCompany: PickedCompany | null;
    onCompanySelect: (company: PickedCompany | null) => void;
    placeholder: string;
    disabled?: boolean;
    className?: string;
}

const toPicked = (company: CompanyOption): PickedCompany => ({
    id: company.id,
    name: company.name,
    company_code: company.company_code ?? '',
    country: company.country ?? '',
});

export function CompanyPicker({ selectedCompany, onCompanySelect, placeholder, disabled = false, className }: CompanyPickerProps) {
    return (
        <CompanySelector
            value={selectedCompany?.id ?? ''}
            onValueChange={(value) => {
                if (!value) onCompanySelect(null);
            }}
            onCompanyResolved={(company) => {
                if ((company?.id ?? '') !== (selectedCompany?.id ?? '')) {
                    onCompanySelect(company ? toPicked(company) : null);
                }
            }}
            // The current value would otherwise have to be re-fetched to render its name.
            seedCompanies={selectedCompany ? [selectedCompany] : []}
            labels={{ placeholder }}
            disabled={disabled}
            className={className}
        />
    );
}
